import "pixi";
import "phaser";


export default class Fog extends Phaser.Group {
    game: Phaser.Game;
    oneFog: Phaser.Sprite;
    twoFog: Phaser.Sprite;
    oneTween: Phaser.Tween | null;
    twoTween: Phaser.Tween | null;

    constructor(game: Phaser.Game, parent?: Phaser.Group) {
        super(game, parent);
        this.game = game;

        this.oneFog = this.game.add.sprite(0, 300, "fog");
        this.twoFog = this.game.add.sprite(-800, 300, "fog");

        this.oneFog.alpha = 0.7;
        this.twoFog.alpha = 0.7;

        this.addMultiple([this.oneFog, this.twoFog]);

        this.resetTween();

    }

    resetTween(){
        this.oneFog.x = 0;
        this.twoFog.x = -800;
        this.oneTween = this.game.add.tween(this.oneFog).to( { x: 800 }, 70000, "Linear", true);
        this.twoTween = this.game.add.tween(this.twoFog).to( { x: 0 }, 70000, "Linear", true);
        this.oneTween.onComplete.add(() =>{
            this.resetTween();
        });
        this.oneTween.start();
        this.twoTween.start();
    }
}



// WEBPACK FOOTER //
// ./src/fog.ts